import { Link } from "react-router-dom";
import { Home, UtensilsCrossed } from "lucide-react";
import { Seo } from "../components/Seo";
import { MaskedLines, Reveal } from "../components/motion";

export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Halaman Tidak Ditemukan — Bakso Tujuh Pemuda"
        description="Halaman yang Anda cari tidak tersedia. Kembali ke beranda Bakso Tujuh Pemuda atau lihat menu kami."
        path="/404"
      />
      <section className="min-h-[80vh] flex items-center justify-center grain relative pt-32 pb-20" data-testid="not-found-page">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <MaskedLines
            as="div"
            lines={[<span className="text-terracotta">404</span>]}
            className="font-display font-black text-8xl sm:text-9xl tracking-tight"
          />
          <Reveal delay={0.3}>
            <h1 className="mt-4 font-display font-black tracking-tight text-3xl sm:text-4xl">
              Aduh, mangkuk ini <span className="italic font-semibold text-terracotta">kosong.</span>
            </h1>
            <p className="mt-4 text-ink-soft leading-relaxed">
              Halaman yang Anda cari tidak ada atau sudah dipindahkan. Tapi tenang — bakso kami selalu ada di Jalan Pengadilan.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/" data-testid="notfound-home-button" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-terracotta text-cream font-bold hover:bg-terracotta-dark transition-colors duration-300">
                <Home size={18} /> Kembali ke Beranda
              </Link>
              <Link to="/menu/" data-testid="notfound-menu-button" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-ink font-bold hover:bg-ink hover:text-cream transition-colors duration-300">
                <UtensilsCrossed size={18} /> Lihat Menu
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
